import { render, staticRenderFns } from "./milling.form.vue?vue&type=template&id=23e5ab64&"
import script from "./milling.form.vue?vue&type=script&lang=js&"
export * from "./milling.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports